import { useContext, useEffect } from "react";
import { Colour } from "../Variables";
import { Card } from "../components/Shared/Card";
import { RouteContext } from "../../contexts/RoutesContext";
import { useSearchParams } from "react-router";

export function ApplicationSubmitted() {
    const routeContext = useContext(RouteContext);
    useEffect(() => {
        routeContext.setRoutes([{ name: "Application submitted", route: null }])
    }, []);
    
    const [queryParameters] = useSearchParams();
    let app = queryParameters.get("app");

    return (
        <Card title={"Application submitted"} headerTheme={Colour.Secondary} headerClasses={""} >
            You have already submitted an application for this position.
        </Card>
    );
}